<template>
  <div class="relative flex flex-col justify-between border border-dark-line rounded-xl overflow-hidden hover:border-accent transition-all fade-in"
       :class="{'animate-border-pulse' : moreThan2MinutesPassed}">
    <div class="flex md:p-6 md:block">
      <img :src="serviceRequest.service.photo.path" alt=""
           class="w-20 h-20 md:w-auto md:h-auto rounded-lg drop-shadow-[0_15px_15px_rgba(0,0,0,0.3)]">

      <div class="flex-1 px-2 md:px-0">
        <div class="flex justify-between mr-4 mt-2 md:mr-0 md:mt-4">
          <span>{{ serviceRequest.service.name }}</span>
          <span v-if="serviceRequest.count">{{ serviceRequest.count }} عدد</span>
        </div>

        <div class="grid grid-cols-2 text-sm mt-2 mr-4 md:mt-4 md:mr-0">
          <h6>ثبت:</h6>
          <span class="text-left">{{ serviceRequest.created_at }}</span>

          <h6>دریافت:</h6>
          <span class="text-left">{{ serviceRequest.seen_date || '-' }}</span>

          <h6>تحویل:</h6>
          <span class="text-left">{{ serviceRequest.delivered_date || '-' }}</span>
        </div>

        <p class="mt-2 text-sm">{{ serviceRequest.description }}</p>
      </div>

    </div>

    <div class="flex justify-between mt-2 md:text-center px-3 mb-4 md:mr-0">
      <VBadge type="info" class="!text-sm" @click="$emit('roomNumber', serviceRequest.room.number)">اتاق {{ serviceRequest.room.number }}</VBadge>
      <VBadge :type="$helper.renderStatusClass(serviceRequest.status)">
        {{ $helper.renderStatus(serviceRequest.status) }}
      </VBadge>
    </div>

    <div class="flex w-full text-sm">
      <button class="w-full center-in-parent py-2 md:py-4 text-accent bg-blue/20 text-blue"
              @click="confirmModal = true; status = 'seen'">
        دیده شده
        <EyeIcon class="w-6 mr-2"/>
      </button>
      <button class="w-full center-in-parent py-2 md:py-4 text-accent bg-green/20 text-green"
              @click="confirmModal = true; status = 'delivered'">
        تحویل
        <BadgeCheckIcon class="w-6 mr-2"/>
      </button>
    </div>

    <VLoadingScreen :show="loading"/>

  </div>

  <ModalConfirm
      title="تایید"
      :text="'آیا از تغییر وضعیت سفارش  ' + serviceRequest.service.name  + ' مطمئن هستید ؟' "
      :show="confirmModal"
      @click="confirmModal = !confirmModal"
      @confirmed="updateStatus"
      @rejected="confirmModal = false"
  />

</template>

<script>
import VBadge from "@/components/General/VBadge";
import {BadgeCheckIcon, EyeIcon} from "@heroicons/vue/outline";
import ModalConfirm from "@/components/Modal/ModalConfirm";
import {updateServiceRequests} from "@/API/API";
import VLoadingScreen from "@/components/General/VLoadingScreen";

export default {
  name: "ServiceRequestCard",
  components: {VLoadingScreen, ModalConfirm, VBadge, EyeIcon, BadgeCheckIcon},
  props: ['serviceRequest'],
  emits: ['updated', 'roomNumber'],
  data() {
    return {
      confirmModal: false,
      status: '',
      loading: false
    }
  },
  computed: {
    moreThan2MinutesPassed() {
      let createdDate = new Date(this.serviceRequest.created_at)
      let diff = (new Date()).getMinutes() - createdDate.getMinutes()
      diff = Math.abs(diff)
      return !this.serviceRequest.delivered_date && diff > 2;
    }
  },
  methods: {
    async updateStatus() {
      this.loading = true
      this.confirmModal = false
      let request = (await updateServiceRequests(this.serviceRequest.id, this.status)).data
      this.loading = false
      this.$emit('updated', request)
    },
  }
}
</script>

<style scoped>
.animate-border-pulse {
  animation: border-pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;;
}

@keyframes border-pulse {
  0%, 100% {
    @apply border-2 border-dark-line
  }
  50% {
    border-color: yellow;
    @apply border-2
  }
}
</style>